import { api } from "@/lib/api";

// Apre un file generato dal server (PDF/Excel) in una nuova scheda con un click sincrono:
// niente blob né fetch asincrona, così iPhone/Safari e la modalità app non bloccano l'apertura
// e la pagina corrente resta dov'è. L'autenticazione viaggia con il cookie di sessione.
export function fileUrl(path, params) {
  const base = (api.defaults.baseURL || "").replace(/\/$/, "");
  const qs = new URLSearchParams(Object.entries(params || {}).filter(([, v]) => v !== undefined && v !== null && v !== "")).toString();
  return `${base}${path}${qs ? `?${qs}` : ""}`;
}

export function openFile(path, params) {
  const url = fileUrl(path, params);
  const a = document.createElement("a");
  a.href = url;
  a.target = "_blank";
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
  return url;
}

export function downloadFile(path, filename, params) {
  openFile(path, params);
  return Promise.resolve();
}
